import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function unpublishCLesson(clessonId: any) {
    const { apiPostUnpublishCLesson } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostUnpublishCLesson}${clessonId}/`);
}
